import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-hours">
        <div className="hours-content">
          <span className="hours-icon">🕐</span>
          <span className="hours-text">Sabah 10 - Gece 03:00'a kadar açığız</span>
        </div>
      </div>
      <div className="header-container">
        <div className="logo">
          <h1>Öz Adıyaman Çiğköfte</h1>
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
          <a href="#home">Anasayfa</a>
          <a href="#products">Ürünler</a>
          <a href="#about">Hakkımızda</a>
          <a href="#contact">İletişim</a>
        </nav>

        <button className="menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
